export const ordersTableColumns = [
	{ id: "collapseButton" },
	{ id: "orderNumber", label: "Накладна", minWidth: 105 },
	{ id: "createdAt", label: "Дата", minWidth: 150 },
	{ id: "clientName", label: "Клієнт", minWidth: 250 },
	{ id: "status", label: "Статус" },
	{ id: "statusNP", label: "Статус НП" },
	{ id: "driver", label: "Водій" },
	{ id: "employee1c", label: "№ 1С", maxWidth: 50 },
	{ id: "managerUser", label: "Менеджер" },
	{ id: "storage", label: "1С склад" },
	{ id: "warehouse", label: "Склад" },
	{ id: "deliveryType", label: "Доставка" },
	{ id: "deliveryAddress", label: "Адрес доставки" },
	{ id: "archived", label: "Архів", minWidth: 90 },
	{ id: "buttons", label: "", minWidth: 65 },
];

export const ordersRowHistoryColumns = [
	{ id: "newStatus", label: "Новий статус" },
	{ id: "userName", label: "Ім'я виконавця" },
	{ id: "userRole", label: "Роль виконавця" },
	{ id: "comment", label: "Наклеєні ТТН" },
	{ id: "comment", label: "Коментар" },
	{ id: "createdAt", label: "Дата" },
];

export const orderStatusTranslationConformity = {
	CREATED: "1.СТВОРЕНИЙ",
	SUBMITTED_FOR_ASSEMBLY: "2.ПРИЙНЯТИЙ СКЛАДОМ",
	ASSEMBLY_STARTED: "3.СКЛАДАННЯ РОЗПОЧАТО",
	ASSEMBLY_FINISHED: "4.ЗБІРКА ЗАВЕРШЕНА",
	ON_A_WAY: "5.В ДОРОЗІ",
	DELIVERED: "6.ДОСТАВЛЕНИЙ",
	UNDELIVERED: "6.НЕДОСТАВЛЕНИЙ",
	MARKED_TTN: "4. НАКЛЕЄНО ТТН",
};

export const deliveryTypeTranslationConformity = {
	Invet: "INVET",
	NP: "NOVA POSHTA",
	UkrPoshta: "UKRPOSHTA",
	Rozetka: "Rozetka",
	MeestExpress: "MeestExpress",
	SelfPickup: "SelfPickup",
};

export const emptyOrder = {
	id: "new-order-id",
	orderNumber: "",
	clientName: "",
	status: "CREATED",
	deliveryType: "Invet",
	archived: false,
	deliveryAddress: "",
	managerId: "",
	storage: "",
	postOrderNumber: "",
};
